/**
 * Created by DynamicDog on 2016-12-13.
 *
 * Simple component that displays the header image and button to create a new project.
 * TODO: Add alert if there's already a project started.
 */
import {Component} from '@angular/core';
import {EtikettService} from "./services/etikett.service";
import {TranslateService} from "./services/translate.service";

@Component({
    selector: 'select-view',
    template: `
            <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
            <meta http-equiv="Pragma" content="no-cache">
            <meta http-equiv="Expires" content="0">
            <div class="header" id="etikettHeader"><span class="number">1</span>{{'Välj typ av etikett'|translate}}</div>
            <div class="selection">
                <div [ngClass]="{'selected': etikettService.shape==='default'}" (click)="onSelectShape('default')"><div class="etikett icon"></div><div class="label">{{'Etikett'|translate}}</div></div>
                <div [ngClass]="{'selected': etikettService.shape==='locketikett'}" (click)="onSelectShape('locketikett')"><div class="locketikett icon"></div><div class="label">{{'Locketikett'|translate}}</div></div>
                <div [ngClass]="{'selected': etikettService.shape==='flasketikett'}" (click)="onSelectShape('flasketikett')"><div class="flasketikett icon"></div><div class="label">{{'Flasketikett'|translate}}</div></div>
                <div [ngClass]="{'selected': etikettService.shape==='bordsplacering'}" (click)="onSelectShape('bordsplacering')"><div class="bordsplacering icon"></div><div class="label">{{'Bordsplacering'|translate}}</div></div>
            </div>
        `,
})

export class SelectViewComponent {

    backgroundImage:string = "";
    selected:string="default"
    constructor(public etikettService:EtikettService,private translate:TranslateService) {
    }

    private onSelectShape(name:string):void {
        this.etikettService.setShape(name);
    }
}


// WEBPACK FOOTER //
// ./app/select.view.ts